export default "__VITE_ASSET__31eb49af__"